<script lang="ts">
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

</script>

<style>
  .card-wrapper {
    padding: 64px 32px;
    margin-top: 160px;
    margin-bottom: 160px;
  }
  .card-wrapper-mobile {
    margin-top: 24px;
  }
  .bottles {
    max-height: 200px;
    margin: 0 auto;
  }

</style>

<div class="fizz-styles">
  <div class="fizz-grid-center">
    <div
      class="fizz-card card-wrapper fizz-bordered fizz-elevation-1 fizz-text-center fizz-flow-24"
      class:fizz-half-width={$LayoutStore.isDesktop}
      class:card-wrapper-mobile={$LayoutStore.isMobile}
    >
      <h1 class="fizz-heading-1">Item Not Found</h1>
      <p class="fizz-text-large fizz-text-subdued">
        The product you're looking for is no longer available. Try another search or
        <UIRouterLink stateName={"layout.home"}>go to the homepage.</UIRouterLink>
      </p>
      <img
        class="bottles"
        src={window["C"]["IMAGE_PATHS"]["item_not_found.png"]}
        alt="Item not found."
      />
    </div>
  </div>
</div>
